import { render, staticRenderFns } from "./ProjectOutputTable.vue?vue&type=template&id=53974fe0&scoped=true"
import script from "./ProjectOutputTable.vue?vue&type=script&lang=ts"
export * from "./ProjectOutputTable.vue?vue&type=script&lang=ts"
import style0 from "./ProjectOutputTable.vue?vue&type=style&index=0&id=53974fe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53974fe0",
  null
  
)

export default component.exports